import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20media%20broadcast%20control%20room%20with%20multiple%20large%20screens%20displaying%20various%20video%20content%2C%20professional%20studio%20environment%20with%20warm%20amber%20and%20coral%20ambient%20lighting%2C%20high%20tech%20broadcasting%20equipment%2C%20cinematic%20atmosphere%2C%20dark%20background%20with%20glowing%20screens%2C%20editorial%20photography&width=1920&height=1080&seq=hero-media-01&orientation=landscape"
        alt="传媒在线观看平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-8 text-center">
        <h1 className="font-heading text-4xl md:text-6xl font-bold text-background-50 mb-6 leading-tight max-w-3xl">
          传媒在线观看
          <span className="block text-2xl md:text-3xl font-medium mt-3 text-background-50/90">
            高清直播点播平台
          </span>
        </h1>
        <p className="text-lg md:text-xl text-background-50/80 mb-10 max-w-2xl leading-relaxed">
          汇聚海量高清视频资源，覆盖新闻、综艺、纪录片、影视剧等全品类内容。
          <strong className="text-background-50 font-medium">无需下载，打开即看，随时随地畅享传媒在线观看服务。</strong>
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/category/xinwen"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-base hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 flex items-center gap-8">
          <div className="text-center">
            <div className="text-3xl font-heading font-bold text-background-50">5000万+</div>
            <div className="text-sm text-background-50/70 mt-1">月活跃用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-3xl font-heading font-bold text-background-50">10万+</div>
            <div className="text-sm text-background-50/70 mt-1">高清视频资源</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-3xl font-heading font-bold text-background-50">200+</div>
            <div className="text-sm text-background-50/70 mt-1">直播频道</div>
          </div>
        </div>
      </div>
    </section>
  );
}